import { IntlProvider } from 'react-intl';

import { Modal } from 'antd';
import AppLocale from 'lngProvider';

import IntlMessages from 'util/IntlMessages';

import styles from '../../ChartCard/styles.module.less';
import ChartInfo from '../../ChartInfo';
import { createBaseActionButtons } from './baseActionButtons';
import { getChartAccess } from './chartAccess';

/**
 * Creates action buttons for chart widgets
 * Includes base buttons (edit, download, delete) plus an info button
 *
 * @param {Object} params - Parameters for creating action buttons
 * @param {Function} params.handleEdit - Handler for edit action
 * @param {Function} params.handleDelete - Handler for delete action
 * @param {Function} params.handleDownload - Handler for download action
 * @param {boolean} params.loading - Whether data is loading
 * @param {boolean} params.downloading - Whether download is in progress
 * @param {Object} params.data - Widget data (contains info.eventType, info.trigger)
 * @param {Object} params.queryParams - Query parameters (contains componentId)
 * @param {Object} params.locale - Locale settings
 * @returns {Array} Array of action button objects
 */
export const getChartActionButtons = ({ handleEdit, handleDelete, handleDownload, loading, downloading, data, queryParams, locale, additionalProps = {} }) => {
  const currentAppLocale = AppLocale[locale?.locale] || AppLocale.en;

  const getLocalizedComponent = idIntl => (
    <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
      <div className={styles.triggerTitle}>
        <IntlMessages id={idIntl} />
      </div>
    </IntlProvider>
  );

  const handleTriggerInfo = () => {
    const titleInfo = getLocalizedComponent('triggers.view.information');

    const componentName =
      data.info.eventType?.components?.find(item => item.id === queryParams?.componentId)?.name ||
      null;
    const content = (
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <ChartInfo
          formName={data.info.eventType?.name}
          componentName={componentName}
          eventName={data.info.trigger?.name}
        />
      </IntlProvider>
    );
    const okText = getLocalizedComponent('button.ok');

    Modal.info({
      title: titleInfo,
      content,
      okText,
      centered: true,
      width: 'auto',
    });
  };

  // Create base buttons using the helper
  const baseButtons = createBaseActionButtons({
    handleEdit,
    handleDelete,
    handleDownload,
    downloading,
    ...getChartAccess(additionalProps.boardSelected),
    iconSize: 'sm',
  });

  // Add additional button specific to charts
  const infoButton = {
    iconName: 'info',
    action: handleTriggerInfo,
    type: 'secondary',
    iconSize: 'sm',
    disabled: loading,
  };

  // Return base buttons + additional button
  return [...baseButtons, infoButton];
};

